import { useQuery } from "react-query";
import { apiListContractEndNoteHistory } from "../../../../../api/contract/apiListContractEndNoteHistory";
import {
  ExtractFnReturnType,
  QueryConfig,
} from "../../../../../lib/react-query";
import { contractKeys } from "../util/contract.query-keys";

export const getContractEndNoteHistory = async ({
  contractId,
}: {
  contractId: string;
}) => {
  const response = await apiListContractEndNoteHistory(contractId);

  return response.items;
};

type QueryFnType = typeof getContractEndNoteHistory;

type UseContractEndNoteHistoryOptions = {
  contractId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useContractEndNoteHistory = ({
  contractId,
  config,
}: UseContractEndNoteHistoryOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: contractKeys.endNoteHistory(contractId),
    queryFn: () => getContractEndNoteHistory({ contractId }),
  });
};
